<template>
  <v-app id="inspire">
    <router-view></router-view>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  created(){
    document.title = "Fund Balances"
    //this.$router.push('/undermaintenance')
  }
}
</script>